var map = {
	"./android-chrome-192x192": 14,
	"./android-chrome-192x192.png": 14,
	"./android-chrome-512x512": 15,
	"./android-chrome-512x512.png": 15,
	"./apple-touch-icon": 16,
	"./apple-touch-icon.png": 16,
	"./favicon-16x16": 17,
	"./favicon-16x16.png": 17,
	"./favicon-32x32": 18,
	"./favicon-32x32.png": 18,
	"./favicon.ico": 71,
	"./mstile-144x144": 19,
	"./mstile-144x144.png": 19,
	"./mstile-150x150": 20,
	"./mstile-150x150.png": 20,
	"./mstile-310x310": 21,
	"./mstile-310x310.png": 21,
	"./mstile-70x70": 22,
	"./mstile-70x70.png": 22,
	"./safari-pinned-tab": 23,
	"./safari-pinned-tab.svg": 23
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70;